import React, { useCallback, useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { AgreeCheckbox } from '@ertelecom/ui-react/components/FormCallback/styledCheckBox';
import { FixedContainer, Wrapper } from '~/src/components/Presentation/styled';
import { Button, Container, Content, Image, Subtitle, Title, FormButton } from '~/src/components/DomRuTv/Header/styled';
import Option from '~/src/components/Presentation/Option';
import { Options } from '~/src/components/Presentation/Header/styled';
import { sendByCall } from '~/src/api/service-request/by-call';
import {
  InputPhone,
  PhoneBlockAutoWidth,
  Img
} from '~/src/components/Banners/Banner/styled';
import { EVENTS, ACTIONS, CATEGORIES } from '~/src/constants/analytics';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import * as ST from '~/src/layout/center/Form/styled';
import { POLICY_PAGE_LINK } from '~/src/constants';

const FixedWidthHeader = ({
  title,
  image,
  imageWebp,
  subtitle,
  buttonText,
  link,
  properties: { speed },
  hasButtonForm,
  potentialHeader,
  city,
  isRKTariff,
}, textColor) => {
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [confirmPopupOpenStatus, setConfirmPopupOpenStatus] = useState(false);
  const [confirmPopupContent, setConfirmPopupContent] = useState(null);
  const [beenStarted, setDataLayer] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseText, setResponseText] = useState('');
  const [isDisabled, setDisabled] = useState(true);
  const clearPhoneRef = useRef();
  const [checkAgreement, setCheckAgreement] = useState(true);

  const onInputChange = useCallback(data => {
      const { clearInput, isValid } = data;
      setDisabled(!isValid);
      clearPhoneRef.current = clearInput;
      setPhoneNumber(data.value);
      if (!beenStarted) {
          dataLayerForCBPhonePush({
            action: ACTIONS.started,
            requestId: null,
            option: 'banner',
          });
          setDataLayer(true);
      }
  }, [beenStarted]);

  const handleSubmit = useCallback(async() => {
    setIsLoading(true);
    setDisabled(true);

    const params = {
      fio: potentialHeader ?? 'Потенциальный клиент',
      phone: phoneNumber,
      petition: 'request_new'
    };

    dataLayerPush({
      event: EVENTS.UAevent,
      category: 'first screen main',
      action: 'click to order',
    });

    const response = await sendByCall(city.domain, params);
    setIsLoading(false);
    clearPhoneRef.current();

    dataLayerForCBPhonePush({
        requestId: null,
        option: 'banner',
        action: response.status ? ACTIONS.finished : ACTIONS.error,
    });

    setResponseText(response.message);
    setConfirmPopupContent(response);
    setConfirmPopupOpenStatus(true);
  }, [city?.domain, phoneNumber]);

  const onClickButtonHandler = () => {
    if (isRKTariff) {
      window.fbq('track', 'Lead');
      window._tmr?.push({ id: '3213734', type: 'reachGoal', goal: 'Lead' });
    }
    window.location = link;
  };

  useEffect(() => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.applicationForm,
        action: checkAgreement ? ACTIONS.clickAgreeBtn : ACTIONS.clickDisagreeBtn,
    });
  }, [checkAgreement]);

  const onChangeAgreementHandler = useCallback(() => {
      setCheckAgreement(!checkAgreement);
  }, [checkAgreement]);

  return (
    <FixedContainer>
      <Wrapper textColor={textColor}>
        <Container>
          <Content>
            <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
            <Title dangerouslySetInnerHTML={{ __html: title }} />
            <Options>
              {
                Boolean(speed) &&
                <Option
                  key='speed'
                  value={speed}
                  text='мбит/с'
                  description='скорость интернета'
                />
              }
              {
                Boolean(isRKTariff) &&
                <Option
                  key='RKchannels'
                  value='от 110'
                  text='ТВ-каналов'
                  description='в подарок'
                />
              }
            </Options>
            {hasButtonForm
              ? <PhoneBlockAutoWidth>
                <InputPhone
                  onChange={onInputChange}
                  placeholder='Номер телефона'
                />

                <FormButton
                  text={'Подключить'}
                  onClick={handleSubmit}
                  disabled={isDisabled || !checkAgreement}
                />
                <AgreeCheckbox
                  data-test='agreement'
                  id={uniqueId()}
                  onChange={onChangeAgreementHandler}
                  isChecked={checkAgreement}
                  agreeUrl={POLICY_PAGE_LINK}/>

              </PhoneBlockAutoWidth>
              : <Button
                data-test='buttonInHeaderForRequest'
                text={buttonText}
                long={(buttonText.length > 25)}
                onClick={onClickButtonHandler}
              />
            }
          </Content>
        </Container>
        {
          <Image>
            <picture>
              <source srcSet={imageWebp} type='image/webp' />
              <Img src={image} alt={title} itemProp='contentUrl' />
            </picture>
          </Image>
        }
      </Wrapper>
      <PopupResult
        isOpen={confirmPopupOpenStatus}
        title={confirmPopupContent?.status ? 'Заявка успешно отправлена' : 'Не удалось отправить заявку'}
        type={confirmPopupContent?.status ? 'success' : 'error'}
        onClose={() => setConfirmPopupOpenStatus(false)}
        text={responseText}
      >
        {confirmPopupContent?.status ? 'Ожидайте звонка специалиста.' : <>Попробуйте позже или напишите нам в&nbsp;<a href='/?openchat'>чат</a></>}
      </PopupResult>
      <ST.Preloader waitStatus={!isLoading}/>
    </FixedContainer>);
};

const mapStateToProps = state => ({
  city: state.city.currentCity,
});

export default connect(mapStateToProps)(FixedWidthHeader);
